import { render, staticRenderFns } from "./ModalVagas.vue?vue&type=template&id=fd196fdc&scoped=true&"
import script from "./ModalVagas.vue?vue&type=script&lang=js&"
export * from "./ModalVagas.vue?vue&type=script&lang=js&"
import style0 from "./ModalVagas.vue?vue&type=style&index=0&id=fd196fdc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd196fdc",
  null
  
)

export default component.exports